import React from 'react'
import Section from '../Section'
import Header, { Title } from '../Header'
import { AttributeColumns, AttributeList } from '../Attribute'
import { roundWithLocale } from 'utils/math'
import Separator from '../Separator'
import copy from './copy'
import FullCopyAttribute from '../FullCopyAttribute'

interface PositionAndSizeProps {
  rotate?: number
  x: number
  y: number
  width: number
  height: number
}

const PositionAndSize = ({
  rotate,
  x,
  y,
  width,
  height,
}: PositionAndSizeProps) => {
  const roundedX = roundWithLocale(x, 2)
  const roundedY = roundWithLocale(y, 2)
  const roundedRotate = `${rotate ? roundWithLocale(rotate, 2) : '0'}º`
  const roundedWidth = roundWithLocale(width, 2)
  const roundedHeight = roundWithLocale(height, 2)

  const sectionCopyValue = copy({
    rotate: roundedRotate,
    x: roundedX,
    y: roundedY,
    width: roundedWidth,
    height: roundedHeight,
  })

  return (
    <>
      <Separator />
      <Section data-testid="inspector-sidebar-position">
        <Header copyValue={sectionCopyValue}>
          <Title>Position and Size</Title>
        </Header>
        <AttributeList>
          <AttributeColumns>
            <FullCopyAttribute label="X" value={roundedX} display="block" />
            <FullCopyAttribute label="Y" value={roundedY} display="block" />
            <FullCopyAttribute
              label="Rotate"
              value={roundedRotate}
              display="block"
            />
          </AttributeColumns>
          <AttributeColumns>
            <FullCopyAttribute
              label="Width"
              value={roundedWidth}
              display="block"
            />
            <FullCopyAttribute
              label="Height"
              value={roundedHeight}
              display="block"
            />
          </AttributeColumns>
        </AttributeList>
      </Section>
    </>
  )
}

export default PositionAndSize
